
<div>
  <div v-if="assignVariableTemplate === 'switch'" class="row">
    <div class="col">
      <strong>Generative AI</strong>
    </div>
    <div class="col-3">
      <cvt-switch
        size="sm"
        color="active"
        type="circular"
        description-type="default"
        :initial-state="genAI.itemAttribute !== undefined"
        @switchToggle="() => repeatToggle()"
      />
    </div>
  </div>
  <div v-if="assignVariableTemplate === 'button' && genAI.itemAttribute === undefined" class="mb-3">
    <cvt-button
      :outlined="true"
      :full-width="true"
      shape="rounded"
      color="light"
      :mode="mode"
      text="Assign A Variable"
      @click="addGenAIField"
    />
  </div>

  <div v-if="assignVariableTemplate === 'button' && genAI.itemAttribute !== undefined" class="mb-3">
    <cvt-button
      :outlined="true"
      :full-width="true"
      shape="rounded"
      color="danger"
      :mode="mode"
      text="Remove Assigned Variable"
      @click="removeGenAIField"
    />
  </div>

  <div
    v-if="genAI.itemAttribute !== undefined && !isBlockSelected"
    class="row no-gutters mt-3"
  >
    <!-- Dynamic Tagging Section -->
    <div
      v-for="level in formLevels"
      :key="toString(level)"
      class="form-level mb-3"
    >
      <div class="form-group">
        <label>{{level.label}}</label>
        <select
          v-model="level.selectedValue"
          :class="{'form-control': true, 'is-invalid': level.selectedValue === null}"
          @change="onSelectionChange(level.level, level.selectedValue)"
        >
          <option value="" disabled>Choose {{ level.label.toLowerCase() }}...</option>
          <template v-if="isImageComponent">
            <option
              v-for="option in level.level === 0 ? level.options.filter(x=> x.value === 'supporting_images'): level.options"
              :key="option.value"
              :value="option.value === 0? '0' : option.value"
            >
              {{ option.label }}
            </option>
          </template>
          <template v-else>
            <option
              v-for="option in level.level === 0 ?level.options.filter(x=> x.value !== 'supporting_images'): level.options"
              :key="option.value"
              :value="option.value === 0? '0' : option.value"
            >
              {{ option.label }}
            </option>
          </template>

        </select>
        <!-- Show preview for selected option -->
        <div v-if="level.selectedValue !== null" class="option-preview mt-2">
          <small class="text-muted">
            <i class="fa fa-eye mr-1"></i>
            {{ getSelectedOptionPreview(level) }}
          </small>
        </div>
      </div>
    </div>

    <!-- Path preview -->
    <div
      v-if="currentPath"
      class="path-preview alert alert-info d-flex p-1 flex-column"
    >
      <strong>Path:</strong>
      <code class="bg-light p-1 rounded text-wrap">{{ currentPath }}</code>
    </div>
  </div>
  <div
    v-if="genAI.itemAttribute !== undefined && isBlockSelected"
    class="row no-gutters mt-3"
  >
    <div class="col-md-12">
      <cvt-input
        v-model="label"
        type="text"
        label="label"
        :clearable="false"
      />
    </div>
  </div>
</div>
